import normalize from 'jsonapi-normalizer'

import {
  asyncReduxFilter
} from 'containers/Async/actions'
import {
  clearEntities,
  updateTables,
} from 'containers/Entity/actions'
import {
  CLEAR_PROJECT_LIST,
  UPDATE_INPUT_VALUE,
  FETCH_PROJECT_LIST
} from './constants'
import {
  getProjectList,
} from 'containers/Project/actions'
import {
  clearData,
} from 'containers/Project/actions'
import {
  error
} from 'containers/App/Notification/actions'

const clearProjectList = () => {
  return {
    type: CLEAR_PROJECT_LIST
  }
}

const updateInputValue = (value) => {
  return {
    type: UPDATE_INPUT_VALUE,
    value
  }
}

const getProjectListAction = (query) => {
  return dispatch => {
    dispatch(clearEntities())
    return dispatch(getProjectList(query))
      .then(data => normalize(data))
      .then(data => dispatch(updateTables(data)))
      .catch(e => dispatch(error('Failed to get projects.')))
  }
}

const getProjectListActionAsync = asyncReduxFilter(
  FETCH_PROJECT_LIST,
  getProjectListAction
)

const initializeProjectList  = () => {
  return (dispatch, getState) => {
    dispatch(clearProjectList())
    dispatch(clearData())
    return dispatch(getProjectListActionAsync())
  }
}

const onEnterPress = (event) => {
  return dispatch => {
    const {
      key,
      target: {
        value
      }
    } = event
    let promise = Promise.resolve(null)
    if (key === 'Enter')
      promise = dispatch(getProjectListActionAsync(value))
    return promise
  }
}

export {
  onEnterPress,
  initializeProjectList,
  updateInputValue,
}
